module.exports = __webpack_public_path__ + "img/Remove.a18f13fb.svg";